import { RouteParam } from ".";
import RequestDeskCreatePage from "../erp/request_desk/request_desk_create";
import RequestDeskListPage from "../erp/request_desk/request_desk_list";
import RequestDeskDetailPage from "../erp/request_desk/request_desk_detail";
import RequestDeskFaultDashboard from "../erp/request_desk/fault_dashboard";
import { ACTION, MODULE } from "../utils/enums";
import { urls } from "../utils/urls";

const request_desk_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.request_desk_list,
    component: RequestDeskListPage,
    main_module: MODULE.request_desk_panel,
    module: MODULE.request_desk,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.raise_request,
    component: RequestDeskCreatePage,
    main_module: MODULE.request_desk_panel,
    module: MODULE.request_desk,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.request_desk_fault_dashboard,
    component: RequestDeskFaultDashboard,
    main_module: MODULE.request_desk_panel,
    module: MODULE.request_desk_fault_dashboard,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: `${urls.request_desk_detail}/:id`,
    component: RequestDeskDetailPage,
    main_module: MODULE.request_desk_panel,
    module: MODULE.request_desk,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default request_desk_routes;
